module.exports = require("core-js/modules/esnext.set.union.js");